const ComboStateService = function ($http, modalService) {
  const service = this;
  service.comboList = [];
  service.activeEditCombo = {};
  service.editModeComboPosition = false;
  service.comboItemsArr = [];
  service.activeComboIndex = -1;
  service.isEditOtionsMode = false;
  service.comboDiscountPrice = 0;
  service.comboBasePrice = 0;
  service.comboWithDiscount = false;
  service.posCtrl = null;
  service.currencySymbol = '₽';
  service.getActiveItem = function () {
    if (service.activeComboIndex >= 0 && service.activeComboIndex < service.comboItemsArr.length) {
      return service.comboItemsArr[service.activeComboIndex];
    }
    return null;
  };
  service.registerItem = function (itemCtrl) {
    service.comboItemsArr.push(itemCtrl);
  };
  service.unregisterItem = function (itemCtrl) {
    var idx = service.comboItemsArr.indexOf(itemCtrl);
    if (idx >= 0) {
      service.comboItemsArr.splice(idx, 1);
    }
  };
  service.setActiveCombo = function (index, comboItem) {
    service.activeComboIndex = index;
    service.activeEditCombo = comboItem;
    service.editModeComboPosition = true;
  };
  service.setActivePosition = function (position) {
    service.isEditOtionsMode = false;
    if (service.activeEditCombo && service.activeEditCombo.PositionOffers) {
      service.activeEditCombo.PositionOffers.forEach(function (item) {
        item.Default = item.OfferId === position.OfferId;
      });
    }
    var activeItem = service.getActiveItem();
    if (activeItem) {
      activeItem.attributesXml = '';
      activeItem.customOptions = [];
      activeItem.getActivePosition();
    }
    service.recalcPrice();
  };
  service.recalcPrice = function () {
    var bundles = service.comboItemsArr.reduce(function (acc, item) {
      var pos = item.activePosition;
      if (!pos) return acc;
      acc.push({
        PositionId: pos.PositionId,
        OfferId: pos.OfferId,
        AttributesXml: item.attributesXml || ''
      });
      return acc;
    }, []);
    if (bundles.length === 0) {
      service.comboBasePrice = 0;
      service.comboDiscountPrice = 0;
      service.comboWithDiscount = false;
      return;
    }
    $http.post('combo/getComboPrice', JSON.stringify(bundles)).then(function (response) {
      if (response.data && response.data.result) {
        let data = response.data.obj;
        if (data) {
          service.comboBasePrice = data.BasePrice;
          service.comboDiscountPrice = data.PriceInGroup;
          service.comboWithDiscount = data.WithDiscount;
        }
      }
    });
  };
  service.setCustomOptionsForActiveItem = function (xml, items) {
    var activeItem = service.getActiveItem();
    if (activeItem) {
      activeItem.attributesXml = xml;
      activeItem.customOptions = items;
    }
  };
  service.resetState = function () {
    service.comboList = [];
    service.activeEditCombo = {};
    service.editModeComboPosition = false;
    service.activeComboIndex = -1;
    service.isEditOtionsMode = false;
    service.comboItemsArr = [];
    service.comboDiscountPrice = 0;
    service.comboBasePrice = 0;
    service.comboWithDiscount = false;
    service.posCtrl = null;
    service.productCtrl = null;
    modalService.destroy('modal_customOptions');
  };
  service.enterOptionsMode = function () {
    service.isEditOtionsMode = true;
  };
  service.exitOptionsMode = function () {
    service.isEditOtionsMode = false;
  };
  service.exitPositionMode = function () {
    service.editModeComboPosition = false;
    service.isEditOtionsMode = false;
  };
  service.setComboList = function (list) {
    service.comboList = list || [];
    service.comboItemsArr = [];
  };
  service.registerProductCtrl = function (ctrl) {
    service.productCtrl = ctrl;
  };
  service.registerPositionsCtrl = function (posCtrl) {
    service.posCtrl = posCtrl;
  };
  service.setOptionsModalOpener = function (fn) {
    service.openCustomOptionsModal = fn;
  };
  service.openCustomOptionsModal = null;
  service.getActiveEditCombo = function () {
    return service.activeEditCombo;
  };
  service.getComboItemsArr = function () {
    return service.comboItemsArr;
  };
  service.getEditModeComboPosition = function () {
    return service.editModeComboPosition;
  };
  service.getActiveComboIndex = function () {
    return service.activeComboIndex;
  };
  service.getIsEditOtionsMode = function () {
    return service.isEditOtionsMode;
  };
  service.setInitialPrices = function (basePrice, discountPrice, withDiscount) {
    service.comboBasePrice = basePrice;
    service.comboDiscountPrice = discountPrice;
    service.comboWithDiscount = withDiscount;
  };
  service.comparePrices = function (priceA, priceB) {
    var parse = function (val) {
      if (typeof val === 'number') return val;
      return parseFloat(String(val).replace(/[\s\xA0]/g, '').replace(/[^\d,.-]/g, '').replace(',', '.'));
    };
    return parse(priceA) > parse(priceB);
  };
  service.getComboDiscountPrice = function () {
    return service.comboDiscountPrice;
  };
  service.getComboBasePrice = function () {
    return service.comboBasePrice;
  };
  service.getComboWithDiscount = function () {
    return service.comboWithDiscount;
  };
  service.updatePriceWithOptions = function (priceNumber) {
    var activeItem = service.getActiveItem();
    if (activeItem && activeItem.activePosition) {
      activeItem.activePosition.PriceWithOptions = priceNumber;
      var priceAdded = activeItem.activePosition.PriceDifference;
      activeItem.activePosition.priceAdded = priceAdded + (priceNumber - activeItem.activePosition.Price);
    }
    service.recalcPrice();
  };
};
ComboStateService.$inject = ["$http", "modalService"];
export default ComboStateService;